import type { ComponentPropsWithoutRef, FC, HTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Image } from '../../shared/Image';
type Props = PropsWithChildren<{
  image?: ComponentPropsWithoutRef<typeof Image>;
  title?: ReactNode;
  text?: ReactNode;
  callToAction?: ReactNode;
}> & HTMLAttributes<HTMLDivElement>;

/**
 * Render a dashboard content card.
 */
export const DashboardContentCard: FC<Props> = ({
  image,
  title,
  text,
  callToAction,
  ...rest
}) => {
  const derivedClassName = twMerge('space-y-4 bg-white p-1', rest.className, 'rounded-md shadow-100');
  return <div {...rest} className={derivedClassName} data-sentry-component="DashboardContentCard" data-sentry-source-file="DashboardContentCard.tsx">
      {image && <Image {...image} className={twMerge('aspect-16/9 rounded-sm', image.className)} />}

      {(title || text || callToAction) && <div className="space-y-4 p-4 pb-6">
          {(title || text) && <div className="space-y-2">
              {title && <div className="headline-md text-marine-high-emphasis">
                  {title}
                </div>}

              {text && <div className="text-sm text-marine-medium-emphasis">
                  {text}
                </div>}
            </div>}

          {callToAction && <div>{callToAction}</div>}
        </div>}
    </div>;
};